import React from 'react';
import PropTypes from 'prop-types';
import PermissionHOC from 'src/hoc/PermissionHOC';
import MenuLinkComponent from './MenuLinkComponent';
import MenuDropdownComponent from './MenuDropdownComponent';

const SideBarMenuComponent = ({
    menus,
}) => {
    const menuItems = menus.map((menu) => (
        [
            <li
                key={menu.title}
                className="header-menu"
            >
                <span>{menu.title}</span>
            </li>,
            menu.items ? menu.items.map((item) => {
                if (item.link) {
                    return (
                        <PermissionHOC
                            scope={item.scope}
                            key={item.title}
                        >
                            <MenuLinkComponent
                                key={item.title}
                                faIcon={item.faIcon}
                                title={item.title}
                                link={item.link}
                                bandage={item.bandage}
                            />
                        </PermissionHOC>
                    );
                }

                return (
                    <PermissionHOC
                        scope={item.scope}
                        key={item.title}
                    >
                        <MenuDropdownComponent
                            key={item.title}
                            faIcon={item.faIcon}
                            title={item.title}
                            bandage={item.bandage}
                            items={item.items}
                        />
                    </PermissionHOC>
                );
            }) : null,
        ]
    ));

    return (
        <div className="sidebar-menu">
            <ul>
                {menuItems}
            </ul>
        </div>
    );
};

const bandageShape = PropTypes.shape({
    title: PropTypes.string,
    faIcon: PropTypes.string,
});
SideBarMenuComponent.propTypes = {
    menus: PropTypes.arrayOf(PropTypes.shape({
        menus: PropTypes.shape({
            title: PropTypes.string,
            link: PropTypes.string,
            items: PropTypes.arrayOf(PropTypes.shape({
                title: PropTypes.string,
                bandage: bandageShape,
                faIcon: PropTypes.string,
                items: PropTypes.arrayOf(PropTypes.shape({
                    bandage: bandageShape,
                    link: PropTypes.string,
                    title: PropTypes.string,
                })),
            })),
        }),
    })).isRequired,
};

export default SideBarMenuComponent;
